import JSEncrypt from 'jsencrypt'

function rsaEncrypt (content) {
  const encryptor = new JSEncrypt()
  const pubKey = '-----BEGIN PUBLIC KEY-----MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANEs4mspVZ2boCx1452RQUq1cqW5mHgIfHjfhwKp9MlctJ89Yk8tLdtqTG+rc+hQ0f2Zk8hsAPD/TJVk2JmKeb8CAwEAAQ==-----END PUBLIC KEY-----'
  encryptor.setPublicKey(pubKey)
  return encryptor.encrypt(content)
}
export default rsaEncrypt
